export default {"src":"/_next/static/media/keys.4941e6fb.svg","height":405,"width":378,"blurWidth":0,"blurHeight":0};